let _locale = localStorage.getItem('bt_locale') || 'en-IN';
let _currency = localStorage.getItem('bt_currency') || 'INR';
let _symbol = localStorage.getItem('bt_symbol') || '₹';

export const initCurrencySettings = (locale, currency, symbol) => {
  _locale = locale || 'en-IN';
  _currency = currency || 'INR';
  _symbol = symbol || '₹';
  localStorage.setItem('bt_locale', _locale);
  localStorage.setItem('bt_currency', _currency);
  localStorage.setItem('bt_symbol', _symbol);
};

export const getCurrencySymbol = () => _symbol;

export const formatCurrency = (amount) => {
  return new Intl.NumberFormat(_locale, {
    style: 'currency',
    currency: _currency,
    minimumFractionDigits: 2,
  }).format(amount || 0);
};

export const formatDate = (dateStr) => {
  if (!dateStr) return '-';
  return new Date(dateStr).toLocaleDateString('en-IN', {
    day: '2-digit', month: 'short', year: 'numeric',
  });
};

export const getStatusBadgeClass = (status) => {
  const map = {
    draft: 'badge-draft',
    sent: 'badge-sent',
    paid: 'badge-paid',
    overdue: 'badge-overdue',
    cancelled: 'badge-cancelled',
  };
  return map[status] || 'badge-draft';
};

export const todayISO = () => new Date().toISOString().split('T')[0];

export const addDays = (dateStr, days) => {
  const d = new Date(dateStr);
  d.setDate(d.getDate() + days);
  return d.toISOString().split('T')[0];
};

export const isOverdue = (invoice) => {
  if (invoice.status === 'paid' || invoice.status === 'cancelled') return false;
  return new Date(invoice.due_date) < new Date(todayISO());
};
